import clsx from 'clsx'
import { ReactComponent as ArrowSvg } from 'images/icons/arrow_select.svg'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import getTestId from 'utils/getTestId'
import { PASSWORD_RULE_KEYS } from 'utils/passwordRules'

import style from './PasswordRulesHint.module.css'

const PasswordRulesHint = () => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  return (
    <div className={style.root}>
      <button
        type="button"
        className={style.toggler}
        onClick={() => setExpanded(prev => !prev)}
        aria-expanded={expanded}
        data-test-id={getTestId('password-rules')}
      >
        <span>{t('password.requirements')}</span>
        <ArrowSvg className={clsx(style.icon, expanded && style.iconExpanded)} />
      </button>
      {expanded ? (
        <ul className={style.list} data-test-id={getTestId('password-rules-list')}>
          {PASSWORD_RULE_KEYS.map(key => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}

export default PasswordRulesHint
